'use strict';

var _ = require('lodash');
var SnapshotSummaryController = function SnapshotSummaryController($scope, $filter, hepService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  $scope.metrics = [{
    metricKey: 'effectedServices',
    metricLabel: 'Effected Services',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }, {
    metricKey: 'totalFareChange',
    metricLabel: 'Total Eff Fare Change',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }, {
    metricKey: 'avgFareChange',
    metricLabel: 'Avg Eff Fare Change',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }, {
    metricKey: 'excludedServices',
    metricLabel: 'Excluded Services',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }, {
    metricKey: 'extendedServices',
    metricLabel: 'Extensions',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }, {
    metricKey: 'newServices',
    metricLabel: 'New',
    metricValue: 0,
    metricFormat: 'NUMBER'
  }];
  $scope.onSelectSnapshotDate = function (evt, selectedSnapshotDate) {
    $scope.$evalAsync(function () {
      _.forEach($scope.metrics, function (metric) {
        metric.metricValue = rmNumberFormat(_.get(selectedSnapshotDate, metric.metricKey, 0), metric.metricFormat);
      });
      $scope.snapshotDate = null;
      $scope.runNumber = null;
      if (selectedSnapshotDate) {
        $scope.snapshotDate = rmMomentFormat(selectedSnapshotDate.snapshotDate, 'DATE_USER_SETTINGS');
        $scope.runNumber = selectedSnapshotDate.runNumber ? selectedSnapshotDate.runNumber.slice(8, 9) : null;
        $scope.showRunNumber = runFrequency > 1;
      }
    });
  };
};
SnapshotSummaryController.$inject = ['$scope', '$filter', 'HepService'];
module.exports = SnapshotSummaryController;